<template>
  <v-container grid-list-md text-xs-center v-if="isDarfPaymentEnabled">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card color="white">
          <v-card-text class="px-0">
            <h2 class="font-weight-light pb-3">Pagamentos DARF - Documento de Arrecadação de Receitas Federais</h2>
            <img class="pb-5" src="@/assets/pay-per-click.png" style="max-width: 400px;" />
            <h2 v-if="partner === 'establishment'" class="font-weight-light">
              {{ staticMessage }} {{ account.fantasy_name }}!
            </h2>
            <h2 v-else class="font-weight-light">
              {{ staticMessage }} {{ partnerName }}!
            </h2>
          </v-card-text>
          <v-list three-line>
            <new-darf-payment />
            <v-divider inset></v-divider>
            <br>
            <darfs-payment-table />
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  <v-container grid-list-md text-xs-center class="background-billing" v-else>
    <v-layout row wrap class="align-bill">
      <v-card class="mx-auto" max-width="600" style="margin-top: 50px;">
        <v-card-text class="text-center">
          <v-icon size="64" color="grey lighten-1" class="mb-4">block</v-icon>
          <h2 class="headline mb-3">Sistema de Pagamento DARF Desabilitado</h2>
          <p class="body-1 grey--text text--darken-1">
            Esta funcionalidade não está disponível no momento. 
            Entre em contato com seu representante para mais informações.
          </p>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/services/event-bus";

export default {
  name: "DarfPayment",
  created() {
    this.$store.dispatch("system/fetchSystemConfiguration").then(() => {
      this.$store.dispatch("account/isDarfPaymentEnabled");
    });
    this.$store.dispatch("account/getAccount");
  },
  mounted() {
    // Se a rota atual termina com "/new", abrir automaticamente o formulário
    if (this.$route.path.endsWith('/new')) {
      this.$nextTick(() => {
        EventBus.$emit("show-new-darf-payment-form");
      });
    }
  },
  computed: {
    ...mapGetters({
      account: "account/account",
      partner: "account/partner",
      partnerName: "account/partnerName",
      isDarfPaymentEnabled: "account/isDarfPaymentEnabled",
    }),
  },
  data() {
    return {
      staticMessage: "Realize pagamentos de DARF (Documento de Arrecadação de Receitas Federais) direto da sua conta digital",
    };
  },
  components: {
    newDarfPayment: () => import("@/components/desktop/bills/NewDarfPayment.vue"),
    darfsPaymentTable: () => import("@/components/desktop/bills/DarfsPaymentTable.vue"),
  },
};
</script>

<style>
  .background-billing {
    background-color: #FFFFFF;
  }
  .align-bill {
    display: block;
    text-align: center;
  }
</style>